export default {
  cookies: {
    title: 'We respect your privacy',
    description:
      'We use cookies to ensure the proper functioning of our website, analyze traffic, and improve our services. You can accept or reject cookies at any time. Your choice can be changed later.',
    accept: 'Accept all',
    reject: 'Reject',
    privacy_policy: 'Privacy Policy'
  }
}
